import { FlexBox, ScrollShadow } from '@dixa/lib-shared-habla';
import * as React from 'react';

import { RichText } from './components/richText';
import { Footer } from './footer';
import { ViewMode } from './hooks/useBulletinEditor';
import styles from './styles.module.scss';
import { TitleInput } from './titleInput';

type BodyProps = {
  /** Flag indicating if changes have been made */
  hasChanges: boolean;
  /** Is the bulletin currently published? */
  isActive: boolean;
  /** Function that is called when the bulletin titel is changed */
  setTitle: (newTitle: string) => void;
  /** Function that is called when the view mode is changed */
  setViewMode: (viewMode: ViewMode) => void;
  /** The bulletin title */
  title: string;
  /** The current view mode */
  viewMode: ViewMode;
  /** File ref to allow uploading of images */
  fileInputRef: React.RefObject<HTMLInputElement>;
  /** Function that is called when file input changes */
  fileInputOnChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

/** Renders the body section of the bulletin board editor page */
export function Body({
  hasChanges,
  isActive,
  setTitle,
  setViewMode,
  title,
  viewMode,
  fileInputRef,
  fileInputOnChange,
}: BodyProps): JSX.Element {
  return (
    <FlexBox className={styles.bodyContainer} flexDirection="column">
      <TitleInput
        readOnly={viewMode === 'saved'}
        title={title}
        setTitle={setTitle}
      />
      <ScrollShadow className={styles.scrollContainer}>
        <RichText
          className={styles.editor}
          readOnly={viewMode === 'saved'}
          placeholder="Write something nice"
          fileInputRef={fileInputRef}
          fileInputOnChange={fileInputOnChange}
        />
      </ScrollShadow>

      <Footer
        viewMode={viewMode}
        setViewMode={setViewMode}
        canShowPublished={isActive && hasChanges}
      />
    </FlexBox>
  );
}
